import React from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Logo } from '../shared/Logo';
import { NavLink } from '../navigation/NavLink';
import { MAIN_NAV_ITEMS } from '../../constants/navigation';
import { InstallButton } from '../shared/pwa/InstallButton';
import { motion, AnimatePresence } from 'framer-motion';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [activeDropdown, setActiveDropdown] = React.useState<string | null>(null);

  return (
    <header className="bg-gradient-to-r from-emerald-800 via-emerald-700 to-emerald-800 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
        <div className="flex items-center justify-between h-20 w-full">
          <Logo />
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1 ml-auto">
            <nav className="flex items-center space-x-1">
              {MAIN_NAV_ITEMS.map(({ to, label }) => (
                <NavLink 
                  key={to} 
                  to={to} 
                  className="relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 
                           hover:bg-emerald-600/50 hover:text-white group"
                >
                  {label}
                  <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-emerald-300 transition-all duration-200 
                                 group-hover:w-full group-hover:left-0"></span>
                </NavLink>
              ))}
            </nav>
            <div className="ml-6">
              <InstallButton />
            </div>
          </div>

          {/* Mobile Menu Button */}
          <motion.button
            whileTap={{ scale: 0.95 }}
            className="lg:hidden p-2 rounded-lg hover:bg-emerald-600/50 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </motion.button>
        </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden border-t border-emerald-600/30 bg-emerald-800/95 backdrop-blur-sm"
          >
            <div className="px-4 py-4 space-y-1">
              {MAIN_NAV_ITEMS.map(({ to, label }) => (
                <motion.div
                  key={to}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <NavLink
                    to={to}
                    className="block px-4 py-3 rounded-lg text-base font-medium 
                             hover:bg-emerald-600/50 hover:text-white transition-all duration-200
                             border-l-4 border-transparent hover:border-emerald-300"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {label}
                  </NavLink>
                </motion.div>
              ))}
              <motion.div 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.2, delay: 0.1 }}
                className="pt-4 border-t border-emerald-600/30"
              >
                <div className="px-4">
                  <InstallButton />
                </div>
              </motion.div>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}